//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { RoleEnum } from '@shared/Enums'
import { EthAddr } from '@shared/SchemaTypes'
import React, { ReactElement } from 'react'

import { Box, Chip, useTheme } from '@mui/material'

import UploadFileIcon from '@mui/icons-material/UploadFile'

import { useOtChainState } from '@react/redux/store'

import { uploadPdfLyt } from '@react/apx/AwsApx'
import ViewDocumentList from '@react/components/elements/ViewDocumentList'
import { logOT } from '@shared/loggingShared'

export default function LytUpload(props: {
  poolAddr: EthAddr
  float?: 'left' | 'right'
  setHasRequiredDocs?: (value: boolean) => void
}): ReactElement {
  const { poolAddr } = props
  const [refreshNumber, setRefreshNumber] = React.useState<number>(0)

  const {
    cognitoUser,
    stageConfiguration: { stageName, restAPIKey },
    userConnection: { roleEnum },
  } = useOtChainState()

  const theme = useTheme()
  const handlePDFSelect = (e: any): void => {
    const file = e.target.files[0]
    if (file && poolAddr && cognitoUser) {
      uploadPdfLyt(stageName, poolAddr, file, restAPIKey, cognitoUser)
        .then(() => {
          logOT.debug('PDF uploaded')
          setRefreshNumber(refreshNumber + 1)
        })
        .catch((e) => {
          logOT.error(e)
        })
    }
  }

  logOT.info('LytUpload', roleEnum, poolAddr)
  return (
    <Box px={3} py={2} sx={{ flexGrow: 1 }}>
      {(roleEnum === RoleEnum.POOL_ADMIN ||
        roleEnum === RoleEnum.BORROWER ||
        roleEnum === RoleEnum.ISSUER ||
        roleEnum === RoleEnum.PROTOCOL_MANAGER) && (
        <>
          <input
            id="contained-PDF-file-lyt"
            style={{ width: 0 }}
            type="file"
            accept="application/pdf"
            onChange={handlePDFSelect}
          />
          <label htmlFor="contained-PDF-file-lyt">
            <Chip
              sx={{
                float: props.float ?? 'right',
                height: '40px',
                width: '150px',
                marginRight: '-24px',
                backgroundColor: theme.palette.fg.main,
                color: '#FFFFFF',
                padding: '11px 16px 11px 16px',
                borderRadius: '6px',
                cursor: 'pointer',
              }}
              icon={<UploadFileIcon />}
              label={'Upload'}
            />
          </label>
        </>
      )}
      <div style={{ width: 1, height: 5, clear: 'both' }}>Documents</div>
      <ViewDocumentList
        refreshNumber={refreshNumber}
        poolAddr={poolAddr}
        setHasRequiredDocs={props.setHasRequiredDocs}
        isLytMode={true}
      />
    </Box>
  )
}
